import React from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";

const UserRoute = ({
  isAuthenticated,
  isQaSuccess,
  component: Component,
  ...rest
}) => {
  let redirectPath = "";
  if (!isAuthenticated) redirectPath = "/login";
  // if (!isQaSuccess) redirectPath = "/securityquestions";
  if (!isQaSuccess) redirectPath = "/securitytoken";
  return (
    <Route
      {...rest}
      render={(props) =>
        redirectPath === "" ? (
          <Component {...props} />
        ) : (
          <Redirect to={redirectPath} />
        )
      }
    />
  );
};

function mapStateToProps(state) {
  return {
    isAuthenticated: !!state.user.token,
    isQaSuccess: !!localStorage.sessionID,
  };
}

export default connect(mapStateToProps)(UserRoute);



// WEBPACK FOOTER //
// ./src/components/routes/UserRoute.js